// extracted by mini-css-extract-plugin
export var cartContainer = "_pc-4";
export var gray = "_pc-1";
export var itemContainer = "_pc-2";
export var itemDetails = "_pc-3";
export var strong = "_pc-0";